import {
  NoData,
  SkeletonLoading,
  NoDataCard,
  FlexibleLayout,
  ListView,
  DetailsView,
  Pagination,
  EventEmitter,
  AppContext,
  useProduct,
  COMMON_CONSTANTS,
  Loader
} from '@nile/components';
import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback
} from 'react';
import { withRouter } from 'react-router-dom';
import { useQuery, NetworkStatus } from '@apollo/client';
import envConfig from '@nile/home/src/Config/env';
import { FormattedMessage } from 'react-intl';
import SizeMe from 'react-sizeme';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { savePersonalization, getPersonalization } from '@nile/graphql';
import { omit, cloneDeep, concat, isEmpty, compact } from 'lodash';
import { getTicketUpdates } from '@nile/mangifera/src/Utils/Hooks';
import { useGlobalState } from '@nile/components/src/Managers/StateManager';
// import * as _ from 'lodash';

const DetailsComponent = (props) => {
  if (!props.listLoading && props?.id) {
    return <props.detailsViewComponent {...props} />;
  }

  if (!props.listLoading && !props?.id) {
    return (
      <div className="fh flex mauto">
        <div className="mauto">
          <NoDataCard
            imageURL={`url(${envConfig.imageRoot}${props?.detailsPageNoDataImage})`}
            text={<FormattedMessage id={props?.noDataMessage} />}
            type="secondary"
            description={
              <FormattedMessage
                id={props?.noDataDescription || 'alert.noTicketsFound.desc'}
              />
            }
          />
        </div>
      </div>
    );
  }
  return props.detailsViewLoading ? <props.detailsViewLoading /> : <Loader />;
};

const ClassicView = ({
  listViews,
  match,
  size,
  searchTerms,
  setViewConditionsCallback,
  listData = [],
  listLoading,
  refetchList,
  getPersonalizationCategory,
  monicaAiOptions = {},
  itemKeyName,
  listInfo,
  globalStateConfigName,
  detailsViewComponent,
  detailsViewLoading,
  cardComponent: CardComponent,
  context,
  defaultFilterCondition = null,
  AdvancedFilterComponent,
  sortConstant,
  noDataMessage,
  noDataDescription,
  module = 'ticket',
  globalStateConditions,
  setGlobalStateConditions,
  detailsPageNoDataImage,
  classicViewHook,
  widths = null
}) => {
  const { width } = size;

  const CLASSIC_ROW_COUNT = 20;

  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const user = {
    firstName: currentUser.firstName,
    userId: currentUser.userId,
    email: currentUser.email,
    lastName: currentUser.lastName
  };

  const [defaultListOptions, setDefaultListOptions] = useState({
    page: 1,
    sort: [
      {
        attribute: 'createdTime',
        order: 'DESC'
      }
    ],
    condition: null
  });

  const isLargeScreen = width >= 1800;
  const isMediumScreen = width >= 1440;
  const isSmallerScreen = width < 1440;

  const selectedItem = classicViewHook?.selectedItem || null;

  const getActiveView = () => {
    const viewData = !isEmpty(listViews)
      ? listViews.find((item) => {
          return item.id === match.params.id;
        })
      : { name: 'All Tickets', id: '1' };
    return viewData;
  };

  const activeView = getActiveView() || context?.activeView || null;

  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);

  // const [globalStateConditions, setGlobalStateConditions] = useGlobalState(
  //   globalStateKeyName,
  //   {
  //     name: activeView?.id,
  //     filterConditions: [],
  //     searchConditions: [],
  //     pageNumber: 1,
  //     personalizedSort: defaultListOptions?.sort,
  //     sort: defaultListOptions?.sort,
  //     conditions: context?.viewConditions ?? null
  //   }
  // );

  const selectedItemRef = useRef(null);
  selectedItemRef.current = selectedItem;

  const flexWidthMap = {
    smallerScreen: [20, 80],
    mediumScreen: [20, 80],
    largeScreen: [20, 80]
  };

  const flags = useFlags();

  const { sendClientEvent, concurrentViewers } = getTicketUpdates(
    selectedItem?.[itemKeyName]
  );

  const searchHandler = (searchText = '') => {
    setSelectedItemWrapper(null);

    if (classicViewHook?.handleSearch) {
      classicViewHook.handleSearch(
        searchText,
        searchTerms,
        setViewConditionsCallback
      );
    }
  };

  const updateFilterConditions = (condition) => {
    setSelectedItemWrapper(null);
    if (condition?.operands && condition?.operands.length === 0) {
      resetGlobalStateConditions('filter');
      return;
    }

    if (classicViewHook?.handleFilter) {
      classicViewHook.handleFilter(condition, setViewConditionsCallback);
    }
  };

  const resetGlobalStateConditions = (type) => {
    if (classicViewHook?.resetFilters) {
      classicViewHook.resetFilters(type, setViewConditionsCallback);

      if (type === 'filter' || type === 'all') {
        context?.updateInvoiceFilter && context?.updateInvoiceFilter(null);
      }
      if (type === 'all') {
        context?.setViewConditions && context?.setViewConditions(null);
      }
    }
  };

  function setSelectedItemWrapper(itemInFocus) {
    if (classicViewHook?.updateSelectedItem) {
      classicViewHook.updateSelectedItem(itemInFocus);
    }
    // 'REGISTER_PAGE' handled inside ticketdetails page.
    if (selectedItemRef.current?.[itemKeyName] !== itemInFocus?.[itemKeyName]) {
      sendClientEvent(
        'UNREGISTER_PAGE',
        selectedItemRef.current?.[itemKeyName]
      );

      if (context?.activeTab?.data) {
        context.activeTab.data[itemKeyName] = itemInFocus?.[itemKeyName];
      }
    }
  }

  const getColumnSortData = () => {
    getPersonalization({
      userId: user?.userId,
      category: getPersonalizationCategory,
      name: activeView?.id
    })
      .then((response) => {
        if (response) {
          const res = response?.data?.getPersonalizationByCategoryAndName;
          if (res !== null) {
            // setOptions({
            //   ...options,
            //   sort: JSON.parse(res.value)
            // });
            setGlobalStateConditions({
              ...globalStateConditions,
              personalizedSort: JSON.parse(res.value),
              sort:
                module === 'invoice'
                  ? [JSON.parse(res.value), ...defaultListOptions?.sort]
                  : JSON.parse(res.value)
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (getPersonalizationCategory !== false) {
      getColumnSortData();
    }
  }, [activeView?.id]);

  useEffect(() => {
    const refetch = () => {
      if (refetchList) {
        refetchList();
      }
    };
    EventEmitter.subscribe('refetchClassicViewList', refetch);
    return () => {
      EventEmitter.unsubscribe('refetchClassicViewList');
    };
  }, [refetchList]);

  const [allItemsList, setAllItemsList] = useState(listData);

  useEffect(() => {
    if (isEmpty(listData)) {
      setSelectedItemWrapper(null);
    }
    setAllItemsList(listData);

    const firstItem = listData[0];
    const ifselectedItemAvailable = () => {
      return listData.some(
        (item) => item[itemKeyName] === selectedItem?.[itemKeyName]
      );
    };

    if (selectedItem && ifselectedItemAvailable()) {
      setSelectedItemWrapper(selectedItem);
    } else if (firstItem) {
      setSelectedItemWrapper(firstItem);
    }
  }, [listData, selectedItem]);

  const monicaAITimeOutRef = useRef(null);

  useEffect(() => {
    if (!isEmpty(monicaAiOptions)) {
      if (monicaAITimeOutRef?.current) {
        clearTimeout(monicaAITimeOutRef.current);
      }
      monicaAITimeOutRef.current = setTimeout(() => {
        EventEmitter.dispatch('showMonicaAI', {
          options: monicaAiOptions
        });
      }, 1000);
    }

    return () => {
      if (monicaAITimeOutRef?.current) {
        clearTimeout(monicaAITimeOutRef.current);
      }
    };
  }, []);

  const detailsPageProps = {
    id: selectedItem?.[itemKeyName],
    key: selectedItem?.[itemKeyName],
    actions: {},
    isClassicView: true,
    listLoading: listLoading,
    detailsViewComponent: detailsViewComponent,
    detailsViewLoading: detailsViewLoading,
    noDataMessage: noDataMessage,
    noDataDescription: noDataDescription,
    invoiceId: selectedItem?.[itemKeyName],
    detailsPageNoDataImage: detailsPageNoDataImage
  };

  return (
    <FlexibleLayout widths={widths}>
      {/* // widths={isLargeScreen ? flexWidthMap.largeScreen : flexWidthMap.mediumScreen} */}
      <ListView
        allItems={allItemsList || []}
        context={context}
        itemsLoading={listLoading}
        isRefetching={listLoading}
        setSelectedItemWrapper={setSelectedItemWrapper}
        sortConstant={sortConstant}
        searchHandler={searchHandler}
        selectedItem={selectedItem}
        resetGlobalStateConditions={resetGlobalStateConditions}
        globalStateConditions={globalStateConditions}
        listInfo={listInfo}
        setGlobalStateConditions={setGlobalStateConditions}
        activeView={activeView}
        user={user}
        selectedRecords={context.records}
        itemKeyName={itemKeyName}
        noDataMessage={noDataMessage}
        getPersonalizationCategory={getPersonalizationCategory}
        module={module}
        defaultSortOption={defaultListOptions?.sort}
        personalizedSort={globalStateConditions?.personalizedSort}
        classicViewHook={classicViewHook}
        components={{
          Card: (otherProps) => (
            <CardComponent
              context={context}
              {...otherProps}
              isClassicView
              updateList={() => {
                EventEmitter.dispatch('refetchClassicViewList');
              }}
            />
          ),
          AdvancedFilterComponent: (otherProps) => (
            <AdvancedFilterComponent
              isClassicView
              iconOnly
              updateCondition={updateFilterConditions}
              conditions={globalStateConditions?.conditions}
              module={module}
              filterConditions={globalStateConditions?.filterConditions}
              viewId={activeView?.id}
              updateFilterCondition={(filterCondition) => {
                // context?.updateInvoiceFilter?.(filterCondition);
                updateFilterConditions(filterCondition);
              }}
            />
          )
        }}
      />
      <DetailsView
        properties={{
          DetailsViewContent: detailsPageProps
        }}
        components={{
          DetailsViewContent: DetailsComponent
        }}
      />
    </FlexibleLayout>
  );
};
export default withRouter(SizeMe()(ClassicView));
